import {
  MetaCalendario,
  ReceitaDespesa,
} from "../model/PlanoDeTrabalho/PlanoAplicacao";

const deconvertCalendario = (
  receitaDespesa: ReceitaDespesa[],
  orgao: string,
  tipo: string
): MetaCalendario[] => {
  const result: MetaCalendario[] = [];
  const filteredContent = receitaDespesa
    .filter((e) => e.tipo === tipo)
    .filter((e) => e.orgao === orgao);

  const arrAnosMetas: string[] = [];
  filteredContent.forEach((receita) => {
    if (
      !arrAnosMetas.includes(
        `${receita.ano}|${receita.meta_execucao_fisico_id}`
      ) //deve haver apenas uma MataCalendario para cada combinação de ano e id de meta de execução
    ) {
      arrAnosMetas.push(`${receita.ano}|${receita.meta_execucao_fisico_id}`);
      result.push({
        ano: receita.ano,
        etapa: receita.etapa,
        fase: receita.fase,
        metaFisica: receita.meta_execucao_fisico_id,
        meses: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      });
    }
  });
  filteredContent.forEach((receita) => {
    const index = result.findIndex((e) => e.ano === receita.ano);
    result[index].meses[receita.mes - 1] = receita.total_meta;
  });

  return result;
};
export default deconvertCalendario;
